// The title format, on the client: `Page name · where you are`.
//
// Applied ONCE, in createInertiaApp's `title` callback, so every page writes
// `<Head title="Audit log" />` and never a separator. That is the whole point:
// twenty-five literals is how the product ended up with four separators, and
// the twenty-sixth screen would have brought a fifth.
//
// The suffix is `title_suffix`, shared by the controller, and it answers which
// yupkit. this is: the tenant's own domain behind the sign-in, and the site's
// address everywhere else. Only a page inside a tenant overrides the default,
// so the console and the auth screens send nothing and get `yupkit.com`.
//
// The reasoning lives in app/services/page_title.rb, which is the same rule for
// the server-rendered `<title>` and `og:title` that a crawler and a link
// preview read. Two runtimes, so two copies of a two-part constant.
// spec/services/page_title_spec.rb reads this file and fails if they stop
// agreeing.
export const TITLE_SITE = 'yupkit.com'
export const TITLE_SEPARATOR = ' · '

/**
 * A bare page name, and where it lives, to the title that goes in the tab.
 *
 * `suffix` is `unknown` rather than `string` because it arrives as a shared
 * prop, which is JSON: a page rendered by a controller that shares nothing has
 * no `title_suffix` at all, and narrowing here is cheaper than every caller
 * proving it. Anything that is not a non-empty string means the site itself.
 */
export function pageTitle(name: string, suffix?: unknown): string {
  const bare = name.trim()

  // A page with no name of its own falls back to the address rather than to the
  // last page's tab.
  if (!bare) return TITLE_SITE

  const where = typeof suffix === 'string' && suffix.trim() ? suffix.trim() : TITLE_SITE

  return `${bare}${TITLE_SEPARATOR}${where}`
}
